var map = {
	"./logo-admin_client_branch.svg": "89eb",
	"./logo-console.svg": "8700",
	"./logo-customer-service.svg": "9af4",
	"./logo-general-center-text.svg": "3cb8",
	"./logo-general.svg": "56c9",
	"./logo-genesis.svg": "39d7",
	"./logo-internal.svg": "ec4d",
	"./logo-parent_client.svg": "0b02",
	"./logo-pos.svg": "d656",
	"./logo-sub-console.svg": "f814"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7af3";